import { inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { PlatformService } from '@seven1/angular/ssr';

@Injectable({
  providedIn: 'root',
})
export class RendererService {
  private _rendererFactory = inject(RendererFactory2);
  private _platform = inject(PlatformService);
  private _renderer: Renderer2;

  constructor() {
    this._renderer = this._rendererFactory.createRenderer(null, null);
  }

  renderHtml(parent: Element, html: string): void {
    if (this._platform.isBrowser) {
      parent.childNodes.forEach((child) => {
        this._renderer.removeChild(parent, child);
      });
      if (!this.startsWithHtmlTag(html)) {
        html = `<div>${html}</div>`;
      }
      const elements = new DOMParser().parseFromString(html, 'text/html').body
        .childNodes;
      elements.forEach((el) => {
        this._renderer.appendChild(parent, el);
      });
    }
  }

  startsWithHtmlTag(s: string): boolean {
    const pattern = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/;
    return pattern.test(s);
  }
}
